import MD5 from 'crypto-js/md5';

export default function (name, email) {
  if (email) {
    return `https://www.gravatar.com/avatar/${MD5(email)}?d=https%3A%2F%2Fui-avatars.com%2Fapi%2F/${name}`;
  }
  return `https://ui-avatars.com/api/${name}`;
}
